import { t } from "@web-monorepo/i18n/macro";
import { appMetadataPairshare, RECEIVE_QUESTION } from "src/pods/pairshare";
import EditableToolContainer from "src/pods/toolkitData/components/EditableToolContainer";
import SavedToolButton from "src/pods/toolkitData/components/SavedToolButton";
import PairShareEdit from "./PairShareEdit";
import PairShareResult from "./PairShareResult";

const QUESTIONS = () => [
  {
    str: t`What are you grateful for today?`,
    dojoId: "pairShareGratefulness",
  },
  {
    str: t`What is something you've grown better at in the last week?`,
    dojoId: "pairShareImprovement",
  },
  {
    str: t`Recall a time you struggled lately. How did you handle it?`,
    dojoId: "pairShareStruggle",
  },
];

export type PairShareContainerProps = {
  params: {
    classId: string;
    mountPoint: string;
    app: string;
  };
};

export default function PairShareContainer(props: PairShareContainerProps) {
  return (
    <EditableToolContainer
      toolType="pairShare"
      title={t`Display a question for students to discuss.`}
      appMetadata={appMetadataPairshare()}
      {...props}
      suggestedTools={QUESTIONS().map(({ str, dojoId }) => ({
        dojoId,
        payload: {
          text: str,
        },
      }))}
      renderItem={({ tool, openEditScreen, showTool }) => (
        <SavedToolButton
          data-name={`pair_share_container:saved_tool_button:${tool._id || tool.dojoId}`}
          key={tool._id || tool.dojoId}
          onRowClick={() => showTool(tool)}
          onEditClick={tool.dojoId ? null : () => openEditScreen(tool)}
          buttonText={tool.payload.text}
        >
          {tool.payload.text}
        </SavedToolButton>
      )}
      renderEditItem={({ onEdit, payload }) => <PairShareEdit onEdit={onEdit} payload={payload} />}
      renderResult={({ tool }) => <PairShareResult question={tool} />}
      getDisplayPayload={(question) => ({
        type: RECEIVE_QUESTION,
        payload: { question },
      })}
    />
  );
}
